import jfLogoURL from '../../../images/editionmanager/jellyfish-logo.png'
import jfIconURL from '../../../images/editionmanager/jellyfish-icon.png'

export const EDITIONMANAGER_GRAPHICS = {
  logo: jfLogoURL,
  jellyfish: jfIconURL
}

